<i18n src="../../../lib/i18n/product/locales.json"></i18n>
<template>
    <Row>
        <navbar></navbar>
        <div class="detail_slide_p9" ref="mybox">
            <div style="position:absolute;top:23%;left: 0;right:0;bottom:0;">
                <i-col :xs="24" :sm="24" :md="24" :lg="24">
                    <p class="details_banner_text">
                        {{$t('p9_details_page_title')}}
                    </p>
                    <div class="detail_slide_p9_img">
                        <img src="../../../assets/go/p9_product_1@2x.png">
                    </div>
                </i-col>
            </div>
        </div>
        <div class="layout-content" style="z-index: 1;">
            <div class="Product-content mogos">
                <div class="Product-content max_width" style="background: #FFFFFF;padding:6% 0 6% 0;">
                    <Row>
                        <Col class="Product-left" :md="13" style="text-align: center;">
                        <img src="../../../assets/store/p9/p9_2.png" class="mogos-logo">
                        </Col>
                        <Col class="Product-right" :md="11" style="text-align: left;">
                        <p class="Product-name">
                            {{$t('p9_details_page_product_title')}}
                        </p>
                        <p class="Product-price">
                            ${{goods_info.goods_price}}
                        </p>
                        <p class="Product-details">
                            {{$t('p9_details_page_product_content')}}
                        </p>
                        <ul>
                            <li class="Product-details-li">{{$t('p9_details_page_product_content1')}}</li>
                            <li class="Product-details-li">{{$t('p9_details_page_product_content2')}}</li>
                            <li class="Product-details-li"> {{$t('p9_details_page_product_content3')}}</li>
                        </ul>
                        <buy :id="parseInt($route.query.id)" :maxCount="parseInt(goods_info.store_count)"></buy>
                        </Col>
                    </Row>
                </div>

                <div class="Product-content">
                    <Row>
                        <i-col class="Product-right" span="24" style="text-align: center;padding:5% 0;">
                            <p class="idual-title">
                                {{$t('p9_details_page_advantage1')}}
                            </p>
                            <p class="idual-text">
                                {{$t('p9_details_page_advantage1_content')}}
                            </p>
                            <div class="idual-i" style="margin: 40px 0;">
                                <Row>
                                    <i-col :xs="2" :sm="4" :md="6" :lg="8" style="color:transparent">c</i-col>
                                    <i-col :xs="20" :sm="16" :md="12" :lg="8">
                                        <i-col span="6">
                                        <span class="battery-img">
                                            <img src="../../../assets/store/p9/pad.png" alt="">
                                        </span>
                                        </i-col>
                                        <i-col span="6">
                                        <span class="battery-img">
                                            <img src="../../../assets/store/p9/phone.png" alt="">
                                        </span>
                                        </i-col>
                                        <i-col span="6">
                                        <span class="battery-img">
                                            <img src="../../../assets/store/p9/pod.png" alt="">
                                        </span>
                                        </i-col>
                                        <i-col span="6">
                                        <span class="battery-img">
                                            <img src="../../../assets/store/p9/stereo.png" alt="">
                                        </span>
                                        </i-col>
                                    </i-col>
                                    <i-col :xs="2" :sm="4" :md="6" :lg="8" style="color:transparent">c</i-col>
                                </Row>
                            </div>
                        </i-col>
                        <div class="igo-product-details-page" style="background: #FFFFFF">
                            <h1>{{$t('p9_details_page_advantage2')}}</h1>
                            <p class="idual-text">{{$t('p9_details_page_advantage2_content')}}</p>
                            <img class="cable-img-1" src="../../../assets/store/p9/p9_bg_2.jpg"/>
                        </div>
                        <i-col class="Product-right" span="24" style="text-align: center;padding:5% 0;">
                            <p class="idual-title">
                                {{$t('p9_details_page_advantage3')}}
                            </p>
                            <p class="idual-text">
                                {{$t('p9_p5_details_page_advantage3_content')}}
                            </p>
                            <div class="idual-i" style="margin: 50px 0;">
                                <Row>
                                    <i-col :xs="2" :sm="4" :md="6" :lg="8" style="color:transparent">c</i-col>
                                    <i-col :xs="20" :sm="16" :md="12" :lg="8">
                                        <i-col span="8">
                                        <span class="battery-imgs">
                                            <img src="../../../assets/store/p9/protect_1.png" alt="">
                                        </span>
                                        </i-col>
                                        <i-col span="8">
                                        <span class="battery-imgs">
                                            <img src="../../../assets/store/p9/protect_2.png" alt="">
                                        </span>
                                        </i-col>
                                        <i-col span="8">
                                        <span class="battery-imgs">
                                            <img src="../../../assets/store/p9/protect_3.png" alt="">
                                        </span>
                                        </i-col>

                                    </i-col>
                                    <i-col :xs="2" :sm="4" :md="6" :lg="8" style="color:transparent">c</i-col>
                                </Row>
                                <Row>
                                    <i-col :xs="2" :sm="4" :md="6" :lg="8" style="color:transparent">c</i-col>
                                    <i-col :xs="20" :sm="16" :md="12" :lg="8" style="margin-bottom:20px;">
                                        <i-col span="8">
                                        <span class="battery-img">
                                            <span>{{$t('p9_p5_details_page_features1')}}</span>
                                        </span>
                                        </i-col>
                                        <i-col span="8">
                                        <span class="battery-img">
                                            <span>{{$t('p9_p5_details_page_features2')}}</span>
                                        </span>
                                        </i-col>
                                        <i-col span="8">
                                        <span class="battery-img">
                                            <span>{{$t('p9_p5_details_page_features3')}}</span>
                                        </span>
                                        </i-col>
                                    </i-col>
                                    <i-col :xs="2" :sm="4" :md="6" :lg="8" style="color:transparent">c</i-col>
                                </Row>
                                <Row>
                                    <i-col :xs="2" :sm="4" :md="6" :lg="8" style="color:transparent">c</i-col>
                                    <i-col :xs="20" :sm="16" :md="12" :lg="8">
                                        <i-col span="8">
                                        <span class="battery-imgs">
                                            <img src="../../../assets/store/p9/protect_4.png" alt="">
                                        </span>
                                        </i-col>

                                        <i-col span="8">
                                        <span class="battery-imgs">
                                            <img src="../../../assets/store/p9/protect_5.png" alt="">
                                        </span>
                                        </i-col>
                                        <i-col span="8">
                                        <span class="battery-imgs">
                                            <img src="../../../assets/store/p9/protect_6.png" alt="">
                                        </span>
                                        </i-col>

                                    </i-col>
                                    <i-col :xs="2" :sm="4" :md="6" :lg="8" style="color:transparent">c</i-col>
                                </Row>
                                <Row>
                                    <i-col :xs="2" :sm="4" :md="6" :lg="8" style="color:transparent">c</i-col>
                                    <i-col :xs="20" :sm="16" :md="12" :lg="8" style="margin-bottom:20px;">
                                        <i-col span="8">
                                        <span class="battery-img">
                                            <span>{{$t('p9_p5_details_page_features4')}}</span>
                                        </span>
                                        </i-col>
                                        <i-col span="8">
                                        <span class="battery-img">
                                            <span>{{$t('p9_p5_details_page_features5')}}</span>
                                        </span>
                                        </i-col>
                                        <i-col span="8">
                                        <span class="battery-img">
                                            <span>{{$t('p9_p5_details_page_features6')}}</span>
                                        </span>
                                        </i-col>
                                    </i-col>
                                    <i-col :xs="2" :sm="4" :md="6" :lg="8" style="color:transparent">c</i-col>
                                </Row>
                                <Row>
                                    <i-col :xs="2" :sm="4" :md="6" :lg="8" style="color:transparent">c</i-col>
                                    <i-col :xs="20" :sm="16" :md="12" :lg="8">
                                        <i-col span="8">
                                        <span class="battery-imgs">
                                            <img src="../../../assets/store/p9/protect_7.png" alt="">
                                        </span>
                                        </i-col>

                                        <i-col span="8">
                                        <span class="battery-imgs">
                                            <img src="../../../assets/store/p9/protect_8.png" alt="">
                                        </span>
                                        </i-col>
                                        <i-col span="8">
                                        <span class="battery-imgs">
                                            <img src="../../../assets/store/p9/protect_9.png" alt="">
                                        </span>
                                        </i-col>

                                    </i-col>
                                    <i-col :xs="2" :sm="4" :md="6" :lg="8" style="color:transparent">c</i-col>
                                </Row>
                                <Row>
                                    <i-col :xs="2" :sm="4" :md="6" :lg="8" style="color:transparent">c</i-col>
                                    <i-col :xs="20" :sm="16" :md="12" :lg="8" style="margin-bottom:20px;">
                                        <i-col span="8">
                                        <span class="battery-img">
                                            <span>{{$t('p9_p5_details_page_features7')}}</span>
                                        </span>
                                        </i-col>
                                        <i-col span="8">
                                        <span class="battery-img">
                                            <span>{{$t('p9_p5_details_page_features8')}}</span>
                                        </span>
                                        </i-col>
                                        <i-col span="8">
                                        <span class="battery-img">
                                            <span>{{$t('p9_p5_details_page_features9')}}</span>
                                        </span>
                                        </i-col>
                                    </i-col>
                                    <i-col :xs="2" :sm="4" :md="6" :lg="8" style="color:transparent">c</i-col>
                                </Row>
                            </div>
                        </i-col>
                    </Row>
                </div>
                <div class="Product-content">
                    <div class="Product-content"
                         style="background-image: linear-gradient(120deg, #FFFFFF 0%, #FDFDFD 30%,#E7E8E9 100%);padding:10% 0 10% 0;">
                        <Row class="max_width" style="max-width: 600px;margin: 0 auto;">
                            <Col class="Product-right" :md="13" style="text-align: left;">
                            <ul class="Parameter">
                                <li>{{$t('details_page_product_parameters')}}</li>
                                <li>{{$t('p9_details_page_product_parameters1')}}</li>
                                <li>{{$t('p9_details_page_product_parameters2')}}</li>
                                <li>{{$t('p9_details_page_product_parameters3')}}</li>
                                <li>{{$t('p9_details_page_product_parameters4')}}</li>
                                <li>{{$t('p9_details_page_product_parameters5')}}</li>
                                <li>{{$t('p9_details_page_product_parameters6')}}</li>
                                <li>{{$t('p9_details_page_product_parameters7')}}</li>
                                <li>{{$t('p9_details_page_product_parameters8')}}</li>
                            </ul>
                            </Col>
                            <Col class="Product-left" :md="11" style="text-align: center;">
                            <img src="../../../assets/store/p9/p9_3.png" class="idual-img">
                            </Col>
                        </Row>
                    </div>
                </div>
                <div class="detail-basis max_width">
                    <ul>
                        <li>{{$t('shopping_notes')}}</li>
                        <li>
                            {{$t('shopping_notes_tip')}}
                        </li>
                    </ul>
                    <guess></guess>
                </div>
            </div>
        </div>
    </Row>
</template>
<script>
    import Swiper from '../../../../static/js/swiper-3.4.2.min'
    import navbar from '../../Common/Navbar.vue'
    import guess from '../../Profiler/Common/Guess.vue'
    import buy from '../../Common/Buy.vue'
    import Signature from '../../../lib/Signature'

    export default {
        data () {
            return {
                value1: 0,
                minus_text: 1,
                scroll: '',
                active: false,
                num: 1,
                goods_info: {}
            }
        },
        components: {
            navbar,
            guess,
            buy
        },
        created () {
            let module = 'index.php/index/goods/goodsinfo'
            let data = {}
            data.sub_time = Signature.timestamp()
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            data.lang = this.$i18n.locale
            data.goods_id = this.$route.params.id || this.$route.query.id
            this.$http.get(process.env.BASEURL + module, {
                params: data
            }).then(function (resp) {
                if (parseInt(resp.data.code) === 2000) {
                    this.goods_info = resp.data.data.goods_info
                }
            }.bind(this))
        },
        mounted () {
            window.addEventListener('scroll', this.init)
        },
        methods: {
            minus: function () {
                if (this.minus_text > 1) {
                    this.minus_text--
                }
            },
            add: function () {
                if (this.minus_text < 99) {
                    this.minus_text++
                }
            },
//        newPos: function (x, windowHeight, pos, adjuster, inertia) {
//          return x + '%' + (-((windowHeight + pos) - adjuster) * inertia ) + 'px'
//        },
            init () {
//          const h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
//          console.log(window.scrollY)
//          console.log(h)
//           获取当前滚动条与窗体顶部的距离
//          let distance = document.documentElement.scrollTop || document.body.scrollTop
//          $('.detail_slide_1').css({'backgroundPosition': '10% '})
            },
            tab (index) {
                this.num = index
            }
        }

    }
</script>
<style scoped>
    @import '../../../assets/css/swiper-3.4.2.min.css';

    .detail_slide_p9 {
        height: 100vh;
        max-height: 760px;
        background: url("../../../assets/go/p5_bg1@2x.jpg") no-repeat center;
        background-size: cover;
        position: relative;
        overflow: hidden;
    }
    .detail_slide_p9_img{
        width: 80%;
        max-width: 500px;
        margin: 0 auto;
        padding-top: 100px;
    }
    .detail_slide_p9_img img{
        width: 100%;
    }
    .detail_slide_2 {
        height: 100vh;
        background: url("../../../assets/store/idual/idual_bg_4@2x.jpg") no-repeat center;
        background-size: cover;
        position: relative;
        overflow: hidden;
    }

    .detail_slide_3 {
        height: 100vh;
        background: url("../../../assets/store/idual/idual_bg_5@2x.jpg") no-repeat center;
        background-size: cover;
        position: relative;
        overflow: hidden;
    }

    .details_banner_text {
        /*font-family: PingFangSC-Regular;*/
        font-size: 32px;
        color: #fff;
        letter-spacing: 0;
        font-weight: 500;
        line-height: 78px;
    }

    .details_banner_text2 {
        /*font-family: PingFangSC-Regular;*/
        font-size: 22px;
        color: #fff;
        letter-spacing: 0;
        line-height: 40px;
    }

    .mogos {
        position: relative;
    }

    .Product-name {
        font-size: 32px;
        color: #1F2D3D;
        line-height: 56px;
    }

    .Product-price {
        font-size: 32px;
        color: #0084ff;
        line-height: 26px;
        margin: 3% 0 3% 0;
    }

    .Product-details-li {
        font-size: 14px;
        color: #5E6D82;
        padding: 0 10px;
    }

    .Product-details {
        /*font-family: Roboto-Regular;*/
        font-size: 16px;
        color: #5E6D82;
        margin-bottom: 10px;
        letter-spacing: 0;
        line-height: 22px;
        padding: 0 20% 2% 0;
    }

    .Product-btn {
        border: 1px solid #0084FF;
        border-radius: 5px;
        height: 50px;
        width: 200px;
        font-size: 20px;
        color: #0084FF;
        background: transparent;
        margin: 5% 6% 0% 0%;
    }

    .Product-btn:hover {
        background: #0084FF;
        color: white;
    }

    .details_card_text div {
        /*font-family: PingFangSC-Regular;*/
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
        border-radius: 0px !important;
        padding: 15px 0;
    }

    .swiper-pagination span p {
        /*font-family: PingFangSC-Regular;*/
        width: 300px;
        text-align: left;
        line-height: 24px;
    }

    .swiper-pagination span p span {
        margin: 0 40px 0 5px;
        color: #fff;
        font-size: 14px;
    }

    .idual-title {
        /*font-family: PingFangSC-Semibold;*/
        font-size: 22px;
        color: #1F2D3D;
        letter-spacing: 0;
        line-height: 40px;
        padding: 0 10%;
    }

    .idual-text {
        /*font-family: PingFangSC-Regular;*/
        font-size: 16px;
        color: #5E6D82;
        letter-spacing: 0;
        line-height: 24px;
        padding: 0 10%;
    }

    .battery-img {
        margin: 0 20px;
    }

    .idual-nano {
        position: absolute;
        right: 20%;
        text-align: left;
        margin-top: 60px;
    }

    .idual-nano li:first-child {
        /*font-family: PingFangSC-Semibold;*/
        font-size: 22px;
        color: #1F2D3D;
        letter-spacing: 0;
        line-height: 40px;
    }

    .idual-nano li {
        /*font-family: PingFangSC-Regular;*/
        font-size: 16px;
        color: #5E6D82;
        letter-spacing: 0;
        line-height: 24px;
    }

    .details_tip {
        /*font-family: PingFangSC-Semibold;*/
        font-size: 22px;
        color: #1F2D3D;
        letter-spacing: 0;
        line-height: 40px;
    }

    .details_tip2 {
        /*font-family: PingFangSC-Regular;*/
        font-size: 16px;
        color: #5E6D82;
        letter-spacing: 0;
        line-height: 24px;
    }

    .detail-basis ul {
        width: 100%;
        margin: 0 auto !important;
        padding: 2% 10px;
    }

    .detail-basis ul li {
        /*font-family: PingFangSC-Regular;*/
        font-size: 16px;
        color: #000000;
        letter-spacing: 0;
        line-height: 24px;
        text-align: left;
    }

    .detail-basis ul li:first-child {
        color: #0084FF;
    }

    .cable-img-1 {
        width: 50%
    }

    /*滚动条*/
    ::-webkit-scrollbar {
        width: 0px;
    }

    .Parameter li {
        /*font-family: PingFangSC-Regular;*/
        font-size: 16px;
        color: #1F2D3D;
        letter-spacing: 0;
        line-height: 24px;
    }

    .Parameter li:first-child {
        font-size: 22px;
        margin-bottom: 20px;
        line-height: 40px;
    }

    @media screen and (max-width: 992px) {
        .Product-left, .Product-right {
            text-align: center !important;
        }

        .idual-nano {
            position: relative;
            text-align: center;
            margin-top: 20px;
            right: 0;
        }

        .idual-nano li:first-child {
            font-size: 16px;
        }

        .idual-nano li {
            font-size: 12px;
        }
    }

    @media screen and (max-width: 768px) {
        .Product-details {
            padding: 0;
        }
        .Product-name{
            font-size: 26px;
        }
        .mogos-logo {
            width: 90%;
        }

        .details_banner_text {
            font-size: 45px;
            line-height: 55px;
            padding: 0 5%;
        }

        .details_banner_text2 {
            margin: 50px 0;
            font-size: 24px;
            line-height: 25px;
        }

        .Product-btn {
            margin: 5% 0 0 0;
        }

        .idual-img {
            width: 50%;
            min-width: 230px;
            margin: 30px 0 0 0px;
        }

        .idual-i img {
            width: 80%;
        }

        .idual-nano li:first-child {
            font-size: 16px;
        }

        .idual-nano li {
            font-size: 12px;
        }
    }

    @media screen and (max-width: 500px) {
        .detail_slide_p9{
            background: url("../../../assets/home/new_home/MOGO-P5-P9@2x.jpg") center no-repeat;
        }
        .details_banner_text {
            font-size: 21px;
            line-height: 35px;
            padding: 0 5%;
        }

        .details_banner_text2 {
            font-size: 14px;
            margin: 15px 0;
            line-height: 20px;
        }

        .Product-name {
            font-size: 24px;
        }

        .Product-details {
            font-size: 14px;
            padding:0 20px;
        }

        .Product-price {
            font-size: 30px;
        }

        .Parameter li {
            font-size: 16px;
            line-height: 30px;
            width: 200px;
            text-align: left;
            margin: 0 auto;
        }


        .idual-i img {
            width: 80%;
        }

        .battery-img img {
            width: 80%;
        }

        .battery-imgs img {
            width: 60%;
        }

        .cable-img-1 {
            width: 90%
        }

        .battery-img {
            margin: 0 10px;
        }

        .idual-title {
            font-size: 18px;
        }

        .idual-text {
            font-size: 14px;
        }
    }

    @media (min-width: 1000px) and (max-width: 1024px) {
        .Product-details {
            padding: 0px 0% 2% 0px;
        }

        .idual-img {
            width: 100%;
            margin: 100px 0 0 100px;
        }
    }
</style>



// WEBPACK FOOTER //
// P9.vue?247216d8